const table = [
    {
        prop: 'Anio',
        label: 'Año',
        minWidth: 100
    },
    {
        prop: 'Mes',
        label: 'Mes',
        minWidth: 100
    },
    {
        prop: 'CodeMun',
        label: 'Cod. Municipio',
        minWidth: 150
    },
    {
        prop: 'Municipio',
        label: 'Municipio',
        minWidth: 200
    },
    /*{
        prop: 'Contrato',
        label: 'Contrato',
        minWidth: 200
    },*/
    {
        prop: 'Region',
        label: 'Region',
        minWidth: 200
    },
    {
        prop: 'Afectados',
        label: 'Afectados',
        minWidth: 200
    },
    {
        prop: 'TimeDisponibilidad',
        label: 'Tiempo Disponibilidad',
        minWidth: 200
    },
    {
        prop: 'PorcIndisponibilidad,',
        label: 'Porcentaje Disponibilidad',
        minWidth: 200
    },
    {
        prop: 'Fecha',
        label: 'Fecha',
        minWidth: 200
    },
    {
        prop: 'HoraInic',
        label: 'Hora Inicio',
        minWidth: 200
    },
    {
        prop: 'HoraFin',
        label: 'Hora Fin',
        minWidth: 200
    },
    {
        prop: 'NivlAfectacion',
        label: 'Nivel Afectación',
        minWidth: 200
    },
    {
        prop: 'Origen',
        label: 'Origen',
        minWidth: 200
    },
    {
        prop: 'Tipificacion',
        label: 'Tipificación',
        minWidth: 200
    },
]

export default table

